<template>
  <div class="home">
    <SurveyForm></SurveyForm>
  </div>
</template>

<script>
import SurveyForm from '@/components/SurveyForm.vue';

export default {
  name: 'SurveyView',
  components: {
    SurveyForm
  }
}
</script>